import { useEffect, useState } from 'react';
import mercadopagoService from '../services/mercadopago.service';

let cached = null;

/** Country/site config from the backend (driven by MP_SITE). Cached for the session. */
export default function useSiteConfig() {
  const [config, setConfig] = useState(cached);

  useEffect(() => {
    if (cached) return;
    mercadopagoService
      .getConfig()
      .then(data => {
        cached = data;
        setConfig(data);
      })
      .catch(() => {});
  }, []);

  return config;
}
